module.exports = __webpack_public_path__ + "img/saab.d11ad40a.svg";